"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import OktaSignIn from "@okta/okta-signin-widget";
export function getOktaSignIn(authClient, flow, state, email) {
  var flowParameter = flow === "login" ? {} : { flow };
  return new OktaSignIn(__spreadValues({
    clientId: authClient.options.clientId,
    redirectUri: authClient.options.redirectUri,
    authClient,
    state,
    // can be any string, it will be passed on redirect callback
    username: email || "",
    i18n: {
      // Overriding English properties
      // See https://github.com/okta/okta-signin-widget/blob/master/packages/%40okta/i18n/src/properties/login.properties
      // for the list of overridable strings
      en: {
        "primaryauth.title": "Sign in",
        "primaryauth.username.placeholder": "Email",
        "oie.remember": "Remember me",
        "oie.kmsi.title": "Remember me",
        "oform.next": "Continue"
      }
    }
  }, flowParameter));
}
